import React from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import {
  Home,
  About,
  Projects,
  Project,
  Services,
  Service,
  Contact,
} from "./app/pages";
import { Header, Footer, Navbar } from "./app/components";

import "./App.css";

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/projects", element: <Projects /> },
    { path: "/projects/:id", element: <Project /> },
    { path: "/services", element: <Services /> },
    { path: "/services/:id", element: <Service /> },
    { path: "/contact", element: <Contact /> },{ path: "/quote", element: <Contact /> },
  ]);
  return routes;
};

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="main-container">
          <Header />
          <Navbar />
          <main className="main-routes">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
